import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mw-1685" }
const _hoisted_2 = {
  class: "satellite-internet-banner-content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "satellite-internet-banner-area",
    style: _normalizeStyle(_ctx.backgroundImageStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sub" }, "أقوى سيرفر IPTV للمشاهدة بدون تقطيع", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-white" }, "نحن الخيار الأول للبث الحي والمحتوى الحصري", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, " من استادات الملاعب الكبرى مباشرة إلى منزلك، عندما تبدأ المباريات الحاسمة، نضمن لك تجربة مشاهدة ثابتة ومثالية بدقة 4K و VIP. ", -1)),
        _createElementVNode("form", {
          class: "check-form position-relative",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.window.open('https://wa.me/447429916178', '_blank')), ["prevent"]))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "اكتب نوع جهازك (شاشة، هاتف، ريسيفر)..."
          }, null, -1),
          _createElementVNode("button", {
            type: "submit",
            class: "btn active position-absolute top-50 end-0 translate-middle-y"
          }, [
            _createElementVNode("span", { class: "border-style" }, "اطلب تجربة مجانية")
          ], -1)
        ]))], 32),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "already" }, [
          _createTextVNode(" هل تريد تفعيل اشتراكك الآن؟ "),
          _createElementVNode("a", {
            href: "https://wa.me/447429916178",
            target: "_blank"
          }, "تواصل معنا مباشرة من هنا.")
        ], -1))
      ])
    ])
  ], 4))
}